import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=1eeb4b5f&scoped=true&"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=1eeb4b5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb4b5f",
  null
  
)

export default component.exports